import { List, Lock, Log } from '@icon-park/react';
import { memo, useMemo } from 'react';

import { LESSON_SEQUENCE_TYPES } from '@didaskill/domain/lessons/constants';
import { Tile } from '@didaskill/ui/design-system';

type SequenceTileProps = {
  title: string;
  subtitle?: string;
  type: LESSON_SEQUENCE_TYPES;
  isDisabled?: boolean;
};

const SequenceTileBase = ({ title, subtitle, type, isDisabled = true }: SequenceTileProps) => {
  const sequenceIcon = useMemo(() => {
    if (isDisabled) {
      return <Lock />;
    }

    if (type === LESSON_SEQUENCE_TYPES.TRAINING) {
      return <List />;
    }

    return <Log />;
  }, [isDisabled, type]);

  return (
    <Tile
      icon={sequenceIcon}
      title={title}
      subtitle={subtitle}
      variant={Tile.VARIANTS.NEUTRAL}
      iconVariant={Tile.VARIANTS.PRIMARY}
      withShadow={false}
      isDisabled={isDisabled}
    />
  );
};

SequenceTileBase.displayName = 'SequenceTile';

export const SequenceTile = memo(SequenceTileBase);
